module.exports = __webpack_public_path__ + "static/media/cammino_3.ebe7eb46.jpg";